// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__cscpw","rootCenter":"LoadMoreObserver_rootCenter__xtSg0","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__2CeHJ"};